// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__dMR8D","title":"ClientCherryInfo_title__3M_c5","itemText":"ClientCherryInfo_itemText__3Psg_"};